import React from 'react';
import { Badge } from 'react-bootstrap';

export const STATUS_COLORS = {
  received: 'secondary',
  processing: 'info',
  completed: 'success',
  failed: 'danger',
};

export const ErrorBadge = ({ children, className, title }) => (
  <Badge
    bg="danger"
    text="white"
    className={className}
    title={title || (typeof children === 'string' ? children : undefined)}
  >
    {children}
  </Badge>
);

export const StatusBadge = ({ status, className, style }) => {
  const bg = STATUS_COLORS[status] || 'secondary';
  const text = status === 'failed' ? 'white' : undefined;

  return (
    <Badge bg={bg} text={text} className={className} style={style}>
      {status}
    </Badge>
  );
};

export const resolveTaskApiVersion = (task) => {
  if (!task || typeof task !== 'object') {
    return 'v2';
  }
  if (task.api_version === 'v3') {
    return 'v3';
  }
  const attrs = task.attributes;
  if (attrs?.api_version === 'v3' || attrs?.recognition_mode === 'client_payload') {
    return 'v3';
  }
  return 'v2';
};

export const ApiVersionBadge = ({ task, className }) => {
  const version = resolveTaskApiVersion(task);
  const isV3 = version === 'v3';

  return (
    <Badge
      bg={isV3 ? 'primary' : 'secondary'}
      text={isV3 ? 'white' : undefined}
      className={className}
    >
      {version.toUpperCase()}
    </Badge>
  );
};
